module.exports = __webpack_public_path__ + "static/media/dwellPass-emblem-map-red-shadow-120.7358ae5e.png";